export const alphaToHex = alpha => `0x${Math.ceil(255 * alpha).toString(16)}`;

export const hexToARGB = (color, alpha = 1.0, fallback = 0x00000000) =>
  color ? parseInt(color.replace('#', alphaToHex(alpha)), 16) : fallback;

export const colorsToNumbers = strings =>
  Object.keys(strings).reduce((colors, colorName) => {
    colors[colorName] = hexToARGB(strings[colorName]);

    return colors;
  }, {});

export const colorsSetToNumbers = colors =>
  Object.keys(colors).reduce((result, mode) => {
    const set = colorsToNumbers(colors[mode]);

    return { ...result, [mode]: set };
  }, {});
